import './navigation';

(function($)
{
	(function()
	{
		const el = document.getElementById("codess-404-type");
		if(!el) return;
		const phrases = ["Verlorenes Kapitel","Verblasste Erinnerung","Unentdeckte Seite","Verborgene Wahrheit","Verschollene Spur","Vergessene Zeile","Leere Seite","Schattige Passage","Verdeckte Botschaft","Verirrte Zeilen","Ungehörte Worte","Verwischte Spuren","Verlassene Geschichte","Unvollendeter Satz","Übersehene Zeile","Verblasster Augenblick"];
		const txt = phrases[Math.floor(Math.random() * phrases.length)];
		let j = 0;
		(function type()
		{
			el.textContent = txt.slice(0, ++j);
			if(j < txt.length) setTimeout(type, 60);
		})();
	})();

	$(".codess-block-hero__headings__text a").hover(function()
	{
		let id = $(this).data("id");
		$(this).add(`.headings-images img[data-id='${id}']`).toggleClass("active");
	});

})(jQuery);

(function()
{
	const wrapper = document.querySelector('.thumbnail-wrapper');
	const img = wrapper ? wrapper.querySelector('img.thumbnail') : null;
	if(!wrapper || !img) return;

	const header = document.querySelector('[data-sticky-header]');
	const mq = window.matchMedia('(min-width: 768px)');

	function setHeaderVar()
	{
		const h = header ? header.getBoundingClientRect().height : 0;
		document.documentElement.style.setProperty('--headerH', h + 'px');
	}

	function applySticky() {
		wrapper.style.position = 'sticky';
		wrapper.style.top = 'calc(var(--headerH, 0px) + 10vh)';
		img.style.display = 'block';
		img.style.transform = 'translateY(-50%)';
		img.style.willChange = 'transform';
	}

	function clearSticky() {
		wrapper.style.position = '';
		wrapper.style.top = '';
		img.style.transform = '';
		img.style.willChange = '';
	}

	function handle(m) {
		setHeaderVar();
		if(m.matches) {
			applySticky();
		}
		else {
			clearSticky();
		}
	}
	if (img.complete) {
		handle(mq);
	}
	else {
		img.addEventListener('load', function()
		{
			handle(mq);
		}, { once: true });
	}

	mq.addEventListener ? mq.addEventListener('change', handle) : mq.addListener(handle);
	window.addEventListener('resize', setHeaderVar, { passive: true });
})();

document.addEventListener("DOMContentLoaded", function() {
	const mq = window.matchMedia("(max-width: 767.98px)");
	const headerCols = document.querySelector('.wp-block-columns.is-layout-flex .wp-block-buttons.is-layout-flex.wp-container-core-buttons-is-layout-765c4724');
	const projects = document.querySelector('.codess-block-projects .projects');

	function placeButton() {
		if (!headerCols || !projects) return;
		if (mq.matches) {
			if (!document.getElementById('projects-btn-clone')) {
				const moved = headerCols.parentElement.cloneNode(true);
				moved.id = 'projects-btn-clone';
				moved.classList.add('projects-btn-mobile');
				const btns = moved.querySelector('.wp-block-buttons');
				if (btns) {
					btns.classList.remove('is-content-justification-right');
					const btn = btns.querySelector('.wp-block-button__link');
					if (btn) btn.classList.add('projects-btn-link-mobile');
				}
				projects.insertAdjacentElement('afterend', moved);
				headerCols.parentElement.style.display = 'none';
			}
		} else {
			const clone = document.getElementById('projects-btn-clone');
			if (clone) clone.remove();
			if (headerCols) headerCols.parentElement.style.display = '';
		}
	}

	placeButton();
	mq.addEventListener ? mq.addEventListener('change', placeButton) : mq.addListener(placeButton);
});
